// extracted by mini-css-extract-plugin
export default {"wrapper":"UserInformer_wrapper__wMUn-","text":"UserInformer_text__iyx6c","icon":"UserInformer_icon__lv1ve","iconEn":"UserInformer_iconEn__KmDu+"};